import * as React from "react";
const SvgCheckmarkP500 = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <rect width={18} height={18} fill="#2CAD5A" rx={9} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m4 9.03 3.483 3.359L13.5 5"
    />
  </svg>
);
export default SvgCheckmarkP500;
